import React, { useEffect, useState } from "react";
import axios from "axios";
import supabase from "../config/supabase";
import "./HouseManagement.css";
import SideNav from '../components/RentalHouses/SideNav';

const API = "https://ikaze-thouse-backend.vercel.app/api/houses";

function HouseManagement() {
  const [houses, setHouses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [search, setSearch] = useState("");

  const [form, setForm] = useState({
    title: "",
    price_usd: "",
    location: "",
    bedrooms: "",
    bathrooms: "",
    description: ""
  });

  useEffect(() => {
    fetchHouses();
  }, []);

  // ================= FETCH HOUSES =================
  const fetchHouses = async () => {
    try {
      const res = await axios.get(API);
      setHouses(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  // ================= FORM CHANGE =================
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // ================= RESET =================
  const resetForm = () => {
    setForm({
      title: "",
      price_usd: "",
      location: "",
      bedrooms: "",
      bathrooms: "",
      description: ""
    });

    setImage(null);
    setEditingId(null);
  };

  // ================= SUPABASE UPLOAD =================
  const uploadImageToSupabase = async () => {
    if (!image) return null;

    // ❌ DO NOT add "houses/" here
    const fileName = `${Date.now()}-${image.name}`;

    const { data, error } = await supabase.storage
      .from("houses")
      .upload(fileName, image);

    if (error) {
      console.log("Upload error:", error);
      throw error;
    }

    const { data: publicData } = supabase.storage
      .from("houses")
      .getPublicUrl(fileName);

    return publicData.publicUrl;
  };

  // ================= SUBMIT (FIXED) =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      let image_url = null;

      // upload image if selected
      if (image) {
        image_url = await uploadImageToSupabase();
      }

      const payload = {
        ...form,
        image_url
      };

      // UPDATE or CREATE
      if (editingId) {
        await axios.put(`${API}/${editingId}`, payload);
      } else {
        await axios.post(API, payload);
      }

      await fetchHouses();
      resetForm();

      alert("Saved Successfully");

    } catch (error) {
      console.error(error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  // ================= EDIT =================
  const handleEdit = (house) => {
    setEditingId(house.id);

    setForm({
      title: house.title || "",
      price_usd: house.price_usd || "",
      location: house.location || "",
      bedrooms: house.bedrooms || "",
      bathrooms: house.bathrooms || "",
      description: house.description || ""
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Delete House?")) return;

      await axios.delete(`${API}/${id}`);

      fetchHouses();
    } catch (error) {
      console.error(error);
    }
  };

  // ================= SEARCH =================
  const filteredHouses = houses.filter(
    (house) =>
      house.title?.toLowerCase().includes(search.toLowerCase()) ||
      house.location?.toLowerCase().includes(search.toLowerCase())
  );

  // ================= UI =================
  return (
    <div className="house-container">
      <SideNav/>
      <h1 className="page-title">
        House Sale Management
      </h1>

      {/* FORM */}
      <form className="house-form" onSubmit={handleSubmit}>

        <input
          type="text"
          name="title"
          placeholder="House Title"
          value={form.title}
          onChange={handleChange}
          required
        />

        <input
          type="number"
          name="price_usd"
          placeholder="Price USD"
          value={form.price_usd}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="location"
          placeholder="Location"
          value={form.location}
          onChange={handleChange}
          required
        />

        <input
          type="number"
          name="bedrooms"
          placeholder="Bedrooms"
          value={form.bedrooms}
          onChange={handleChange}
          required
        />

        <input
          type="number"
          name="bathrooms"
          placeholder="Bathrooms"
          value={form.bathrooms}
          onChange={handleChange}
          required
        />

        <textarea
          name="description"
          placeholder="Description"
          value={form.description}
          onChange={handleChange}
        />

        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
        />

        <button type="submit">
          {loading
            ? "Saving..."
            : editingId
            ? "Update House"
            : "Add House"}
        </button>

      </form>

      {/* SEARCH */}
      <div className="search-section">
        <input
          type="text"
          placeholder="Search House..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* GRID */}
      <div className="houses-grid">

        {filteredHouses.map((house) => (

          <div key={house.id} className="house-card">

            <img
              src={house.image_url}
              alt={house.title}
              className="house-image"
            />

            <div className="house-content">

              <h2>{house.title}</h2>

              <h3>
                ${Number(house.price_usd).toLocaleString()}
              </h3>

              <p>📍 {house.location}</p>
              <p>🛏 {house.bedrooms} Bedrooms</p>
              <p>🚿 {house.bathrooms} Bathrooms</p>

              <p>{house.description}</p>

              <div className="card-buttons">

                <button
                  className="edit-btn"
                  onClick={() => handleEdit(house)}
                >
                  Edit
                </button>

                <button
                  className="delete-btn"
                  onClick={() => handleDelete(house.id)}
                >
                  Delete
                </button>

              </div>

            </div>

          </div>

        ))}

      </div>

    </div>
  );
}

export default HouseManagement;
